module.exports = __webpack_public_path__ + "static/media/filter.c19f02b5.svg";